<template>
  <div class="home-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-content container">
        <div class="hero-text">
          <h1 class="hero-title">
            Your Trusted <br /><span class="accent-font"
              >Distribution Partner</span
            >
          </h1>
          <p class="hero-subtitle">
            Delivering quality packaged food products and beverages across
            Idukki for over 13 years. Reliable, efficient, and dedicated to your
            business growth.
          </p>
          <button class="btn-primary" @click="scrollToProducts">
            Shop Now
          </button>
        </div>
        <div class="hero-image">
          <div class="image-blob"></div>
          <img
            src="https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&q=80&w=800"
            alt="Fresh Bread"
            class="floating-image"
          />
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features-section container">
      <h2 class="section-title main-title">Why Choose Us?</h2>
      <p class="section-subtitle">
        With 13 years of expertise in the FMGC distribution sector, we ensure
        timely and reliable service for all your retail needs.
      </p>

      <div class="features-grid">
        <div class="feature-column left">
          <div class="feature-item" v-animate-on-scroll>
            <div class="feature-icon">🚚</div>
            <div class="feature-text">
              <h3>Efficient Logistics</h3>
              <p>
                Operating with our own self-managed delivery vehicles to ensure
                timely and reliable product transportation.
              </p>
            </div>
          </div>
          <div class="feature-item" v-animate-on-scroll>
            <div class="feature-icon">🌟</div>
            <div class="feature-text">
              <h3>13 Years Experience</h3>
              <p>
                A well-established reputation for reliability and quality
                service across the entire Idukki region.
              </p>
            </div>
          </div>
        </div>

        <div class="feature-image-center" v-animate-on-scroll>
          <img
            src="https://images.unsplash.com/photo-1549931319-a545dcf3bc73?auto=format&fit=crop&q=80&w=600"
            alt="Bread Basket"
            class="basket-image"
          />
        </div>

        <div class="feature-column right">
          <div class="feature-item" v-animate-on-scroll>
            <div class="feature-icon">🛍️</div>
            <div class="feature-text">
              <h3>Premium FMCG</h3>
              <p>
                Wholesale distribution of top-tier packaged foods, snacks, and
                beverages from trusted brands.
              </p>
            </div>
          </div>
          <div class="feature-item" v-animate-on-scroll>
            <div class="feature-icon">👥</div>
            <div class="feature-text">
              <h3>Dedicated Team</h3>
              <p>
                A professional workforce of 10 staff members committed to smooth
                operations and customer satisfaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      // Data cleaned up after products extraction
    };
  },
  mounted() {},
  methods: {
    scrollToProducts() {
      this.$router.push("/products");
    },
    scrollToAbout() {
      // Optional: preserve about scroll if needed elsewhere
    },
  },
  directives: {
    animateOnScroll: {
      mounted(el) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add("is-visible");
                observer.unobserve(el);
              }
            });
          },
          { threshold: 0.1 }
        );
        observer.observe(el);
      },
    },
  },
};
</script>

<style scoped>
.home-page {
  font-family: "Plus Jakarta Sans", sans-serif;
  color: #5d4037;
  background-color: #fffdfa;
  padding-top: 80px;
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.accent-font {
  font-family: "Dancing Script", cursive;
  color: #efa962;
  font-size: 1.25em;
  font-weight: 700;
}

/* --- Hero Section --- */
.hero {
  padding: 6rem 0;
  background: radial-gradient(circle at 85% 20%, #fff5e6 0%, transparent 45%);
}

.hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
}

.hero-text {
  flex: 1.2;
}

.hero-title {
  font-size: clamp(2.5rem, 5vw, 4.2rem);
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 2rem;
  color: #3e2723;
}

.hero-subtitle {
  font-size: 1.15rem;
  color: #8d6e63;
  line-height: 1.8;
  margin-bottom: 3rem;
  max-width: 550px;
}

.btn-primary {
  background-color: #efa962;
  color: white;
  border: none;
  padding: 1.1rem 3rem;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  box-shadow: 0 10px 20px rgba(239, 169, 98, 0.2);
}

.btn-primary:hover {
  background-color: #e69642;
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(239, 169, 98, 0.4);
}

.hero-image {
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
}

.image-blob {
  position: absolute;
  width: 130%;
  height: 130%;
  background: #fff5e6;
  border-radius: 50% 50% 50% 50% / 60% 40% 60% 40%;
  z-index: 0;
  top: -15%;
  left: -15%;
  animation: blobMorph 15s infinite alternate;
}

@keyframes blobMorph {
  0% {
    border-radius: 50% 50% 50% 50% / 60% 40% 60% 40%;
  }
  100% {
    border-radius: 40% 60% 45% 55% / 50% 50% 50% 50%;
  }
}

.floating-image {
  position: relative;
  z-index: 1;
  width: 110%;
  max-width: 550px;
  border-radius: 20px;
  transform: rotate(-3deg);
  box-shadow: 30px 30px 80px rgba(0, 0, 0, 0.08);
  transition: transform 0.5s ease;
}

.floating-image:hover {
  transform: rotate(0deg) scale(1.02);
}

/* --- Features --- */
.features-section {
  padding: 8rem 0;
}

.main-title {
  font-size: 3.5rem;
  text-align: center;
  margin-bottom: 1rem;
}

.section-subtitle {
  text-align: center;
  color: #8d6e63;
  max-width: 650px;
  margin: 0 auto 5rem;
  font-size: 1.1rem;
}

.features-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  align-items: center;
  gap: 3rem;
}

.feature-column {
  display: flex;
  flex-direction: column;
  gap: 6rem;
}

.feature-item {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.feature-item.is-visible {
  opacity: 1;
  transform: translateY(0);
}

.left .feature-item {
  text-align: right;
  flex-direction: row-reverse;
}

.feature-icon {
  font-size: 1.8rem;
  background: white;
  min-width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.feature-text h3 {
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
  color: #3e2723;
  font-weight: 700;
}

.feature-text p {
  font-size: 0.95rem;
  line-height: 1.7;
  color: #8d6e63;
}

.basket-image {
  width: 100%;
  border-radius: 50%;
  aspect-ratio: 1;
  object-fit: cover;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.12);
  border: 15px solid white;
}

@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
  }
  .feature-image-center {
    grid-column: span 2;
    order: -1;
    max-width: 400px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
  }
  .hero-subtitle {
    margin: 0 auto 3rem;
  }
  .features-grid {
    grid-template-columns: 1fr;
  }
  .feature-image-center {
    grid-column: span 1;
  }
  .left .feature-item {
    text-align: left;
    flex-direction: row;
  }
  .hero-title {
    font-size: 3rem;
  }
  .main-title {
    font-size: 2.8rem;
  }
}
</style>
